<template>
    <div class="container">
        <div class="paramForm">
            <el-form :model="params" label-width="90px" class="approveForm">
                <el-row>
                    <el-form-item label="产品状态">
                        <el-select v-model="params.status" clearable width="100px">
                            <el-option v-for="item in statusOptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <div class="paramFormButton">
                <el-button type="primary" icon="el-icon-search" @click="handleCurrentChange(1)">搜索</el-button>
            </div>
        </div>
        <div class="tableTool">
            <el-button type="primary" icon="el-icon-printer" @click="exportExcel">导出</el-button>
            <el-button type="primary" icon="el-icon-plus" @click="openCreate">新增</el-button>
        </div>
        <el-table border ref="tableRef" :data="tableData" class="table-show-current" highlight-current-row @row-dblclick="openEdit">
            <el-table-column prop="id" label="产品ID" align="center" width="100"></el-table-column>
            <el-table-column prop="name" label="产品名称" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column label="产品周期" align="center">
                <template slot-scope="scope">
                    <span>{{scope.row.cycle}} 天</span>
                </template>
            </el-table-column>
            <el-table-column prop="multiple" label="杠杆倍数" align="center">
                <template slot-scope="scope">
                    <span>{{scope.row.multiple}} X</span>
                </template>
            </el-table-column>
            <el-table-column label="日利率" align="center">
                <template slot-scope="scope">{{showApy(scope.row.dayRate)}}</template>
            </el-table-column>
            <el-table-column label="最低购买金额" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.minAmount">{{scope.row.minAmount}} USDT</span>
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column label="最高购买金额" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.maxAmount">{{scope.row.maxAmount}} USDT</span>
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column label="结算方式" align="center">
                <template slot-scope="scope">
                    <span>{{showApyText(scope.row.hkfs)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="产品状态" align="center">
                <template slot-scope="scope">
                    <div>
                        <span style="margin-right: 10px;">{{ statusMap[scope.row.status] }}</span>
                        <el-button type="text" @click="switchStatus(scope.row)" v-if="scope.row.status == 'INVISIBLE'">上线</el-button>
                        <el-button type="text" @click="switchStatus(scope.row)" v-if="scope.row.status == 'NORMAL'">下线</el-button>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="sort" label="展示顺序" align="center"></el-table-column>
            <el-table-column prop="updatedAt" label="更新时间" align="center" width="150"></el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                :current-page="pageInfo.pageNum"
                :page-size="pageInfo.pageSize"
                :page-sizes="[10, 20, 50, 100, 200]"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
        <!-- 编辑弹出框 -->
        <el-dialog :title="isCreate?'创建产品':'修改产品'" :visible.sync="editDialogVisible" class="abow_dialog" @close="closeDialog" center>
            <el-form ref="formRef" :model="form" :rules="rules" label-width="150px" class="approveForm">
                <el-row>
                    <el-form-item label="产品名称" prop="name">
                        <el-input v-model="form.name"  ></el-input>
                    </el-form-item>
                    <el-form-item label="产品周期" prop="cycle">
                        <el-input-number v-model="form.cycle"></el-input-number>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="杠杆倍数" prop="multiple">
                        <el-input-number v-model="form.multiple" ></el-input-number>
                    </el-form-item>
                    <el-form-item label="日利率" prop="dayRate">
                        <el-input v-model="form.dayRate" ></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="最低购买金额" prop="minAmount">
                        <el-input-number v-model="form.minAmount" :min="0"></el-input-number>
                    </el-form-item>
                    <el-form-item label="最高购买金额" prop="maxAmount">
                        <el-input-number v-model="form.maxAmount" :min="0"></el-input-number>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="产品状态">
                        <el-select v-model="form.status">
                            <el-option v-for="item in statusOptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="展示顺序" prop="sort">
                        <el-input-number v-model="form.sort" ></el-input-number>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="返利方式">
                        <el-select v-model="form.hkfs">
                            <el-option v-for="item in hkfsOptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                   
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmUpdate">提交</el-button>
                <el-button @click="closeDialog">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { aldServiceApi } from '@/api/api-ald';
import { exportData1,exportData2 } from '@/assets/js/exportExcel';
import { isInteger,isPositiveInteger, isNumber,isPositiveNumber,isRate } from '@/assets/js/validator';
export default {
    data() {
        return {
            rules: {
                name: [{ required: true, message: ' ' }],
                multiple: [{ required: true, message: ' ' }],
                cycle: [{ required: true, message: '必须是大于等于0的整数',trigger: 'blur', validator: isInteger }],
                apy:[{ required: true, message: '必须是大于等于0的数字' ,trigger: 'blur', validator: isNumber}],
                sort:[{ required: true, message: '必须是大于等于0的整数',trigger: 'blur', validator: isInteger }],
                minAmount:[{ required: true, message: '必须是大于等于0的整数',trigger: 'blur', validator: isInteger }],
                maxAmount:[
                    { required: true, message: '必须是大于等于0的整数',trigger: 'blur', validator: isInteger },
                    { validator: this.validateMaxAmount, trigger: 'blur' }
                ]
            },
            params:{},
            total:0,
            pageInfo: {
                pageNum: 1,
                pageSize: 10
            },
            tableData:[],
            editDialogVisible: false,
            isCreate:false,
            form: {},
        };
    },
    created() {
        this.statusOptions = this.findDict("FTF_PRODUCT_STATUS");
        this.statusMap = this.listToMap(this.statusOptions,"code","name");
        this.hkfsOptions = this.findDict("FTF_PRODUCT_HKFS");
        this.handleSearch();
    },
    methods: {
        openCreate(){
            this.isCreate = true;
            this.form = {};
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            }
            this.editDialogVisible = true;
        },
		showApyText(text){
			if (text=='NORMAL'){
				return "每日返息";
			}else if(text=='MaturityRebate'){
				return "到期返息";
			}
			else if(text=='Compound'){
				return "复利复息,到期返息";
			}
		},
        switchStatus(row){
            this.$confirm('切换此产品的状态吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                aldServiceApi.updateProductStatus({id:row.id}).then(res => {
                    if (res.result) {
                        this.$message.success('操作成功');
                        this.handleSearch();
                    } else {
                        if(res.msg){
                            this.$message.error(res.msg);
                        }else{
                            this.$message.error("操作失败");
                        }
                    }
                });
            });
        },
        openEdit(data) {
            this.isCreate = false;
            this.form = JSON.parse(JSON.stringify(data));
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            }
            this.editDialogVisible = true;
        },
        closeDialog() {
            this.editDialogVisible = false;
        },
        confirmUpdate() {
             this.$refs.formRef.validate(valid => {
                if (!valid) {
                    return;
                }
                this.$confirm('确定提交？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    aldServiceApi.updateProduct(this.form).then(res => {
                        if (res.result) {
                            this.$message.success('提交成功');
                            this.closeDialog();
                            this.handleSearch();
                        } else {
                            if(res.msg){
                                this.$message.error(res.msg);
                            }else{
                                this.$message.error("提交失败");
                            }
                        }
                    });
                });
            });
        },
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            this.handleSearch();
        },
        handleCurrentChange(val) {
            this.pageInfo.pageNum = val;
            this.handleSearch();
        },
        handleSearch() {
            aldServiceApi.findProductPageList(this.params,this.pageInfo).then(res => {
                this.tableData = res.records;
                this.total = res.total || 0;
            });
        },
        exportExcel() {
            if(!this.tableData || this.tableData.length==0){
                this.$message.warning({message: "没有可导出的数据",duration: 600})
                return;
            }
            let header = ['产品ID', '产品名称','产品周期','杠杆倍数','产品年化','最低购买金额','最高购买金额', '结算方式','产品状态', '展示顺序', '更新时间'];
            let columns = ['id', 'name', 'cycle','multiple','apy','minAmount','maxAmount','hkfs','status','sort',"updatedAt"];
            
            let data = this.tableData.map(r => columns.map(c => {
                let val = r[c];
                if(c == 'valueTotal'){
                    return r["priceOld"] * r["numTotal"];
                }else if(c == 'curValueTotal'){
                    return r["priceCur"] * r["numTotal"];
                }else if(c == 'minAmount' || c == 'maxAmount'){
                    return val ? val + ' USDT' : '-';
                }else if (c == 'hkfs'){
					return this.showApyText(val);
				}else{
                    return val;
                }   
            }));
            exportData2(header,data,"杠杆池产品数据");
        },
        validateMaxAmount(rule, value, callback) {
            if (this.form.minAmount && value && value <= this.form.minAmount) {
                callback(new Error('最高购买金额必须大于最低购买金额'));
            } else {
                callback();
            }
        }
    }
};
</script>
<style lang='less' scope>
span.status_CANCEL{
    color:red;
}
span.status_CONFIRM{
    color:green;
}
span.status_PENDING{
    color:gray;
}
.productEditor{
    width: 100%;
    .ql-toolbar{
        display: none;
    }
    .ql-container{
        border: 1px solid #cccccc !important;
    }
    .ql-editor{
        min-height: 250px;
    }
}
</style>